import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "decs"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["if"];
const _hoisted_5 = ["onClick"];

const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-top",
  style: {
    "font-size": "22px"
  }
}, null, -1);

const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "decs"
};
const _hoisted_10 = ["set"];
const _hoisted_11 = {
  class: "btngroup"
};

const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-top",
  style: {
    "font-size": "22px"
  }
}, null, -1);

const _hoisted_13 = [_hoisted_12];
const _hoisted_14 = {
  key: 2
};
const _hoisted_15 = {
  class: "decs"
};
const _hoisted_16 = ["innerHTML"];
const _hoisted_17 = {
  class: "btngroup"
};

const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-top",
  style: {
    "font-size": "22px"
  }
}, null, -1);

const _hoisted_19 = [_hoisted_18];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MoblieTicket = _resolveComponent("MoblieTicket");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_MoblieTicket, {
    show: $data.ticket.show,
    "onUpdate:show": _cache[0] || (_cache[0] = $event => $data.ticket.show = $event),
    questionType: $data.ticket.questionType,
    question: $data.ticket.question,
    questionRecord: $data.ticket.questionRecord
  }, null, 8, ["show", "questionType", "question", "questionRecord"]), $props.step.type == 'questionAnswer' && _ctx.userType == 'user' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    innerHTML: $props.step.content
  }, null, 8, _hoisted_3)]), _createElementVNode("div", {
    class: "btngroup",
    if: $props.step.answerStep.length == 0 && $options.clickNextQuestionStep()
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.step.answerStep, (_answerStep, _answerStepIndex) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["btn", $options.btnClass($props.disabled, _answerStep.selected)]),
      key: _answerStepIndex,
      onClick: $event => {
        $options.clickNextQuestionStep(_answerStep);
      }
    }, _toDisplayString(Number(_answerStepIndex) + 1) + "." + _toDisplayString(_answerStep.content), 11, _hoisted_5);
  }), 128)), $props.step.index != 0 && $props.step.answerStep.length ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["btn", $options.btnClass($props.disabled)]),
    onClick: _cache[1] || (_cache[1] = (...args) => $options.clickBackPreStep && $options.clickBackPreStep(...args))
  }, _hoisted_7, 2)) : _createCommentVNode("", true)], 8, _hoisted_4)])) : $props.step.type == 'login' && _ctx.userType == 'user' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    set: $options.loadIdentify()
  }, _toDisplayString(_ctx.user.id ? _ctx._t("loginSuccess") : _ctx._t("loginNeed")), 9, _hoisted_10)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    class: _normalizeClass(["btn", $options.btnClass($props.disabled)]),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.clickBackPreStep && $options.clickBackPreStep(...args))
  }, _hoisted_13, 2)])])) : $props.step.type == 'goToChat' && _ctx.userType == 'user' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
    innerHTML: $props.step.content
  }, null, 8, _hoisted_16)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
    class: _normalizeClass(["btn", $options.btnClass($data.unsolvedDisabled)]),
    onClick: _cache[3] || (_cache[3] = $event => $options.clickChatNow($props.question))
  }, _toDisplayString(_ctx._t('chatNow')), 3), _createElementVNode("div", {
    class: _normalizeClass(["btn", $options.btnClass($props.disabled)]),
    onClick: _cache[4] || (_cache[4] = (...args) => $options.clickBackPreStep && $options.clickBackPreStep(...args))
  }, _hoisted_19, 2)])])) : _createCommentVNode("", true)], 64);
}